module.exports = __webpack_public_path__ + "assets/img/newer-gift-en.c858d2f0.png";